import { useState } from 'react';

interface Props {
  initFileUrl?: string;
  handleChange?: (fileUrl: string) => void;
}

function useFileService({ initFileUrl, handleChange }: Props) {
  const [file, setFile] = useState<File | null>(null);
  const [fileUrl, setFileUrl] = useState(initFileUrl || '');

  const handleFile = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        setFile(file);
        setFileUrl(e.target?.result as string);
        handleChange?.(e.target?.result as string);
      };
      reader.readAsDataURL(file);
    }
  };

  return { file, fileUrl, handleFile, setFileUrl };
}

export default useFileService;
